import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

const RouteIcon = ({ children }) => {
  return (
    <Box
      sx={{
        width: "20px",
        height: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& > *": {
          // Esto aplicará los estilos a cualquier hijo directo
          width: "15px !important",
          height: "15px !important",
          fontSize: "15px !important",
        },
      }}
    >
      {children}
    </Box>
  );
};

RouteIcon.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RouteIcon;
